<template>
  <div class="row event-list">
    <event-list-item class="item" :class="{center: index % 3 === 1}" 
      v-for="(item, index) in eventList" :key="index" :data="item"></event-list-item>
  </div>
</template>

<script>
import EventListItem from '@/components/news-monitor/EventListItem';
import QuestionQuery from '@/rest/questionQuery';
import authService from '@/services/authService';

export default {
  data() {
    return {
      eventList: [],
      username: ''
    };
  },
  async created() {
    if (this.$route.query.name) {
      this.$emit('change', 'sourceHome');
      this.username = authService.getLoggedUserName();
      QuestionQuery.homeHotEventList(this.username).then(res => {
        this.eventList = res.map(item => {
          return {
            count: item.count,
            id: item.id,
            index: parseInt(item.index, 10),
            name: item.name
          };
        });
      });
    } else {
      const count = 15;
      const eventListDate = await QuestionQuery.getHotEventList(count);
      this.eventList = eventListDate.map(item => {
        return {
          count: item.count,
          id: item.id,
          index: parseInt(item.index, 10),
          name: item.name
        };
      });
    }
  },
  components: {
    EventListItem
  }
};
</script>

<style lang="scss" scoped>
.event-list {
  flex-wrap: wrap;
  .item {
    margin-top: 24px;
    &.center {
      margin-left: 24px;
      margin-right: 24px;
    }
  }
}
</style>
